var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-button',_vm._g(_vm._b({},'ion-button',_vm.$attr,false),_vm.$listeners),[_c('span',{staticClass:"span-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }